import { computed, Injectable, signal } from "@angular/core";
import { TenantConfig } from "../../initializer/models/tenant.model";

@Injectable({
    providedIn:'root'
})
export class AuthStore{
    private  tenant = signal<TenantConfig | null>(null);

  readonly tenantConfig=computed(()=> this.tenant());

  setTenantInfo(config:TenantConfig | null){
    this.tenant.set(config);
  }
}